import React from 'react'

function Nav(){   
    return(
        <nav role="navigation">
            <ul>
                <li><a href="#">Home</a></li>
                {/* <li><a href="#">Covid-19</a></li> */}
            </ul>
        </nav>
    )
}

export default Nav